import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Button from '../components/ui/Button';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Компонент ContactsPage - страница "Контакты"
 */
const ContactsPage = () => {
  const { darkMode, toggleDarkMode } = useTheme();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Здесь может быть логика отправки формы
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-200">
      {/* Фоновый узор */}
      <div className="fixed inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] dark:bg-[radial-gradient(#1f2937_1px,transparent_1px)] [background-size:20px_20px] opacity-20 pointer-events-none"></div>

      {/* Навигационная панель */}
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />

      {/* Основное содержимое */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <section className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">Свяжитесь с нами</h1>
          <p className="text-lg text-gray-700 dark:text-gray-300">
            Мы всегда рады вашим вопросам и отзывам.
          </p>
        </section>

        {/* Контактная информация */}
        <section className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="flex items-start">
            <Mail className="h-6 w-6 text-indigo-600 dark:text-indigo-400 mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Email</h3>
              <p className="text-gray-600 dark:text-gray-400">
                info@gensio.ru
              </p>
            </div>
          </div>
        </section>

        {/* Форма обратной связи */}
        <section className="mb-16">
          {submitted ? (
            <div className="text-center text-indigo-600 dark:text-indigo-400">
              <h2 className="text-2xl font-semibold mb-2">Спасибо за сообщение!</h2>
              <p>Мы свяжемся с вами в ближайшее время.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium mb-1">
                  Имя
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium mb-1">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium mb-1">
                  Сообщение
                </label>
                <textarea
                  name="message"
                  id="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                ></textarea>
              </div>
              <div className="text-center">
                <Button type="submit" primary className="px-8 py-3">
                  Отправить
                </Button>
              </div>
            </form>
          )}
        </section>

        {/* Призыв к действию */}
        <section className="text-center">
          <h2 className="text-2xl font-semibold mb-4">Хотите узнать больше?</h2>
          <Button
            className="px-8 py-3"
            onClick={() => navigate('/faq')}
          >
            FAQ
          </Button>
        </section>
      </main>

      {/* Футер */}
      <Footer />
    </div>
  );
};

export default ContactsPage;
